exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .checkout-step-payment-info .card-number-container {\n  height: 31px;\n}\n\n.pc .checkout-step-payment-info .card-number-container.flex-microform-focused {\n  border-color: #367c2b;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(54, 124, 43, 0.6);\n}\n\n.pc .checkout-step-payment-info .billing-payment {\n  border-bottom: 1px solid #dddddd;\n  margin-bottom: 15px;\n}\n\n.pc .checkout-step-payment-info .billing-address h5 {\n  margin-bottom: 15px;\n}\n\n.pc .checkout-step-payment-info .billing-address .sync-shipping-and-billing {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n", ""]);

// exports
